import {
    composeSearchUrlFromSearchString,
    decomposeSearchStringToParamsForDisplay
} from "../../../../src/common/service/urlHandler.js";
import { howLongAgo } from "../../../../src/common/service/dateFormatter.js";
import { combineFilterParams } from "../../../../src/common/service/searchPanel.js";

/**
 * 簡易版検索履歴パネル
 *
 * @param props
 * @return {JSX.Element}
 * @constructor
 */
export const SimpleSearchPanel = (props) => {
    const searchParam = decomposeSearchStringToParamsForDisplay(props.search.searchString);
    const combinedFilterParams = combineFilterParams(searchParam, props.filterDefinitions, props.modalViewModel.translations);

    return (
        <a href={composeSearchUrlFromSearchString(props.search.searchString)} className="c-panelBox_in" rel="nofollow">
            {searchParam.keyword && <span className="p-job_list--kw">{decodeURIComponent(searchParam.keyword)}</span>}
            {searchParam.location && <span
                className="p-job_list--loc">{searchParam.keyword ? 'in ' : ''}{decodeURIComponent(searchParam.location)}</span>}
            <p className="p-job_description">{combinedFilterParams}</p>
            <div className="p-job_bottom">
                <p className="p-job_source">{howLongAgo(props.search.addTime, props.modalViewModel.translations)}</p>
            </div>
        </a>
    );
}
